import React from 'react';

function LocationSection() {
  return (
    <section className="section location-section" id="lokasi" aria-labelledby="location-title">
      <div className="container location-layout">
        <div className="location-copy">
          <p className="eyebrow eyebrow-dark">Temukan kami</p>
          <h2 id="location-title">Lokasi</h2>
          <address>
            <strong>Klinik Hipnoterapi Candradimuka</strong>
            Perumahan Cibubur Mansion Blok E3 No.1<br />
            Kec. Cileungsi, Kab. Bogor<br />
            Jawa Barat 16820
          </address>
          <p className="location-phone">Telp/WhatsApp: <a href="tel:+6281264656688">0812-6465-6688</a></p>
          <div className="location-actions">
            <a className="button button-dark" href="https://maps.app.goo.gl/S6uor" target="_blank" rel="noopener noreferrer">Buka di Google Maps <span aria-hidden="true">↗</span></a>
            <a className="review-link" href="https://maps.app.goo.gl/S6uor" target="_blank" rel="noopener noreferrer">Beri ulasan</a>
          </div>
        </div>
        <div className="map-frame">
          <iframe
            title="Peta lokasi Klinik Hipnoterapi Candradimuka"
            src="https://www.google.com/maps?q=Cibubur+Mansion+Blok+E3+No.1+Cileungsi&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
          <span className="map-caption">Cibubur · Kabupaten Bogor</span>
        </div>
      </div>
    </section>
  );
}

export default LocationSection;